export function detectTouch() {
  return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
